import React, { useState, useCallback } from 'react'
import cn from 'classnames'
import { useCaptureEventOutsideElement } from '../hooks/useCaptureEventOutsideElement'

const Selector = ({
  options,
  value,
  onChange,
  keyField = 'id',
  labelKey = 'label',
  onOpenChange,
  empty = 'Select...',
}) => {
  const [open, setOpen] = useState(false)
  const selectedOption = options.find((a) => a[keyField] === value)

  const toggleOpen = useCallback(() => {
    const v = !open
    setOpen(v)
    onOpenChange && onOpenChange(v)
  }, [open, onOpenChange])

  const selectOption = useCallback(
    (option) => {
      onChange(option ? option[keyField] : null)
      setOpen(false)
      onOpenChange && onOpenChange(false)
    },
    [value]
  )

  const handleClose = useCallback(() => {
    if (!open) return
    setOpen(false)
    onOpenChange && onOpenChange(false)
  }, [open, setOpen, onOpenChange])
  const elemRef = useCaptureEventOutsideElement('click', handleClose)

  return (
    <div ref={elemRef} className={cn('selector', { open })}>
      <div
        className={cn('selector-header', 'flex justify-content-space-between align-items-center', 'font-size-s')}
        onClick={() => toggleOpen()}>
        <div className={cn('all-caps line-height-1', 'no-margin-bottom', !value && open && 'option selected')}>
          {selectedOption ? selectedOption[labelKey] : empty}
        </div>
        <div>
          <svg width="24" height="24" className="display-block">
            <use xlinkHref={`/assets/glyphs/glyphs.svg#${open ? 'chevron-up' : 'chevron-down'}`} />
          </svg>
        </div>
      </div>
      {open && (
        <div className={cn('selector-body', 'background-white')}>
          <div className={cn('options')}>
            {!!value && (
              <div
                className={cn('option', 'all-caps line-height-1', 'no-margin-bottom', { selected: !value })}
                onClick={() => selectOption(null)}>
                {empty}
              </div>
            )}
            {options.map((option) => (
              <div
                key={option[keyField]}
                className={cn('option', 'all-caps line-height-1', 'no-margin-bottom', {
                  selected: value === option[keyField],
                })}
                onClick={() => selectOption(option)}>
                {option[labelKey]}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Selector
